// TODO: add this line animation https://blog.olivierlarose.com/demos/svg-bezier-curve
"use client"

import { Heading, Text } from "@chakra-ui/react"
import { Flex, FlexProps } from "@chakra-ui/react/flex"
import { Separator } from "@chakra-ui/react/separator"
import { HStack } from "@chakra-ui/react/stack"
import React from "react"

type SectionTitleProps = Omit<FlexProps, "direction"> & {
  title?: string
  preface?: string
  subTitle?: string | React.ReactNode
  centered?: boolean
  line?: boolean
  noPadding?: boolean
  haveBg?: boolean | undefined
  delay?: number
}

const SectionTitle: React.FC<SectionTitleProps> = ({
  centered = false,
  children,
  delay = 0,
  haveBg = false,
  line = false,
  noPadding = false,
  preface,
  subTitle,
  title,
  ...props
}) => {
  return (
    <Flex
      alignItems={centered ? "center" : "flex-start"}
      bgColor={haveBg ? "bg.paper" : "transparent"}
      borderRadius={haveBg ? "2xl" : "inherit"}
      flexDirection="column"
      px={{
        base: noPadding ? 0 : 12,
        md: noPadding ? 0 : 14,
        lg: noPadding ? 0 : 16,
      }}
      py={{
        base: noPadding ? 4 : 8,
        md: noPadding ? 4 : 12,
        lg: noPadding ? 4 : 14,
      }}
      w={"100%"}
      zIndex={3}
      {...props}
    >
      {preface && (
        <HStack
          alignItems="center"
          className="preface"
          justifyContent={centered ? "center" : "flex-start"}
          mb={undefined === title ? 0 : { base: 0, md: 2 }}
          position="relative"
          width="100%"
        >
          <Text
            _empty={{ display: "none" }}
            as={"p"}
            className="preface-text"
            color={{ base: "primary.500", _dark: "primary.200" }}
            display="inline"
            fontFamily={"code"}
            fontSize={{ base: "xs", md: "md" }}
          >
            {preface}
          </Text>
          {line && (
            <Separator
              as="hr"
              borderColor="border.emphasized"
              flexGrow="1"
              marginLeft="12px"
              marginRight="12px"
              variant="solid"
              width="auto"
              zIndex="-1"
            />
          )}
        </HStack>
      )}
      <>
        {title && (
          <Heading
            as="h2"
            className="title"
            color={"fg"}
            display={"flex"}
            fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
            mb={subTitle ? { base: 0, md: 2 } : 0}
            position={"relative"}
            textAlign={centered ? "center" : "left"}
          >
            {children}
            {title}
          </Heading>
        )}
      </>
      {subTitle && (
        <Text
          _empty={{ display: "none" }}
          className="sub-title"
          color={"fg.muted"}
          fontFamily={"body"}
          fontSize={{ base: "sm", md: "md" }}
          mt={{ base: 0, md: 1 }}
          textAlign={centered ? "center" : "left"}
        >
          {subTitle}
        </Text>
      )}
    </Flex>
  )
}

export default SectionTitle
